import { render, staticRenderFns } from "./clock-face.vue?vue&type=template&id=118a0ee8&scoped=true&"
import script from "./clock-face.vue?vue&type=script&lang=js&"
export * from "./clock-face.vue?vue&type=script&lang=js&"
import style0 from "./clock-face.vue?vue&type=style&index=0&id=118a0ee8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118a0ee8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('118a0ee8')) {
      api.createRecord('118a0ee8', component.options)
    } else {
      api.reload('118a0ee8', component.options)
    }
    module.hot.accept("./clock-face.vue?vue&type=template&id=118a0ee8&scoped=true&", function () {
      api.rerender('118a0ee8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/clock-time-picker/clock-face.vue"
export default component.exports